import section from './section';

const conditionals = { section };

export default conditionals;
